<template>
    <div class="search main-top-border main-bg">
        <div class="main-wrap">
            <div class="crumb-nav">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="crumb">
                    <el-breadcrumb-item :to="{ path: '/' }">买兰花</el-breadcrumb-item>
                    <el-breadcrumb-item>选择分类</el-breadcrumb-item>
                    <el-breadcrumb-item v-if="chooseTag.length>0">
                        <ul class="yiChoose">
                            <li :key="index"  v-for="(tag,index) in chooseTag">
                                <el-tag
                                        :closable="true"
                                        :disable-transitions="false"
                                        size="small"
                                        effect="plain"
                                        @close="handleCloseTag(tag)"
                                        class="tag"
                                >
                                    {{tag.name}}
                                </el-tag>
                            </li>

                        </ul>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="search-box">
                <ul class="scree-type">
                    <li class="scree-name">分类:</li>
                    <li class="type-item">
                        <ul class="type-list">
                            <li :class="{selected:oneTypeId==v.id}" v-for="(v,i) in typeList" :key="i" @click="chooseCurrentType(v,i)">{{v.typeName}}</li>
                        </ul>
                    </li>
                </ul>
                <ul class="scree-type">
                    <li class="scree-name">特点:</li>
                    <li class="type-item">
                        <ul class="type-list">
                            <li :class="{selected:twoTypeId==v.id}" v-for="(v,i) in typeTwoList" :key="i" @click="chooseCurrentTowType(v,i)">{{v.typeName}}</li>
                        </ul>
                    </li>
                </ul>
                <!--<ul class="scree-type">-->
                    <!--<li class="scree-name">专业:</li>-->
                    <!--<li class="type-item">-->
                        <!--<ul class="type-list">-->
                            <!--<li :class="{selected:treCurrentIndex==i}" v-for="(v,i) in majorList" :key="i" @click="chooseCurrentMajorType(v,i)">{{v.typeName}}</li>-->
                        <!--</ul>-->
                    <!--</li>-->
                <!--</ul>-->
                <ul class="sort-type">
                    <li class="scree-name">排序：</li>
                    <ul class="type-item">
                        <li :class="{'selected':rank==1}" @click="rank=1">默认排序</li>
                        <li :class="{'selected':rank==2}" @click="rank=2">销量排序 <i class="el-icon-top"></i></li>
                        <li :class="{'selected':rank==3}" @click="rank=3">价格排序 <i class="el-icon-top"></i></li>
                    </ul>
                    <!--<li class="isBaoYou">
                        <el-checkbox v-model="isBaoYou">包邮</el-checkbox>
                    </li>-->
                </ul>
            </div>
            <goods-item :goodsList="goodsList" :nowTime="nowTime" v-if="nowTime"></goods-item>
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout=" prev, pager, next,total, jumper"
                    style="text-align: center;padding:20px;"
                    :page-size.sync="pageSize"
                    :total="totalPage">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import GoodsItem from '../../components/goods/goodsItem'
    export default {
        data(){
            return {
                minPrice:'',
                maxPrice:'',
                isBaoYou:false,
                treCurrentIndex:0,
                typeList:[],//全部分类列表
                typeTwoList:[
                    {
                        id:-1,
                        typeName:'全部'
                    }
                ],//二级分类列表
                majorList:[
                    {
                        id:-1,
                        typeName:'全部'
                    },
                    {
                        id:1,
                        typeName:'传统品种'
                    },
                    {
                        id:2,
                        typeName:'下山新品'
                    },{
                        id:3,
                        typeName:'组培品种'
                    },
                    {
                        id:4,
                        typeName:'已开花'
                    },
                    {
                        id:5,
                        typeName:'带花苞'
                    },
                    {
                        id:6,
                        typeName:'不带花'
                    }
                ],
                chooseTag:[],//已选中的标签
                rank:1,//1默认 2销量 3价格
                oneTypeId:-1,//一級分類ID
                oneTypeName:'',
                twoTypeId:-1,//二级分類ID
//                goodsName:'',//搜索value
                currentPage:1,//当前页
                pageSize:20,//每页条数
                totalPage:0,//总共条数
                goodsList:[],
                nowTime:''

            }
        },
        components:{
            GoodsItem
        },
        computed:{
        },
        mounted(){
            console.log('this.$route.params',this.$route)
            this.oneTypeId=this.$route.params.oneTypeId?this.$route.params.oneTypeId:this.$route.query.oneTypeId?this.$route.query.oneTypeId:-1;
            this.oneTypeName=this.$route.params.oneTypeName?this.$route.params.oneTypeName:this.$route.query.oneTypeName?this.$route.query.oneTypeName:'';
            this.twoTypeId=this.$route.params.twoTypeId?this.$route.params.twoTypeId:this.$route.query.twoTypeId?this.$route.query.twoTypeId:-1;
            this.twoTypeName=this.$route.params.twoTypeName?this.$route.params.twoTypeName:this.$route.query.twoTypeName?this.$route.query.twoTypeName:'';
            this.goodsName=this.$route.params.goodsName?this.$route.params.goodsName:this.$route.query.goodsName?this.$route.query.goodsName:'';
            this.getActiveGoodsList();
        },
        methods:{
            getActiveGoodsList(){
//                console.log('this.$route.params',this.$route.params)
                this.getAllTypeData();
                if(this.oneTypeId){
                    if(this.oneTypeName){
                        this.chooseTag=[{
                            id:this.oneTypeId,
                            level:1,
                            name:this.oneTypeName
                        }]
                    }
                }else {
                    this.oneTypeId=-1
                }
                if(this.twoTypeId){
                    if(this.twoTypeName){
                        this.chooseTag.push(
                            {
                                id:this.twoTypeId,
                                level:2,
                                name:this.twoTypeName
                            })
                    }
                }else {
                    this.twoTypeId=-1
                }
                this.getAllGoodsList();
            },
            handleCloseTag(tag){
                this.chooseTag.splice(this.chooseTag.indexOf(tag), 1);
                if(this.chooseTag.length===0){
                    this.twoTypeId=-1;
                    this.oneTypeId=-1;
                    this.getAllGoodsList();
                    return ;
                }
                if(this.chooseTag[0].level===1){
                    this.twoTypeId=-1;
                }
                if(this.chooseTag[0].level===2){
                    this.oneTypeId=-1;
                }
                this.getAllGoodsList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getAllGoodsList();
            },
            chooseCurrentType(oneItem,index){//选中当前项
                this.oneTypeId=oneItem.id;
                this.twoTypeId=-1;
                this.chooseTag=[
                    {
                       id:oneItem.id,
                       level:1,
                       name:oneItem.typeName
                    },
                ]
                let  twoTypeList = [
                    {
                        id:-1,
                        typeName:'全部'
                    }
                ]
                if(oneItem.id!=-1){
                    twoTypeList.push(...this.typeList[index].twoTypes);

                }
                this.typeTwoList=twoTypeList;
                this.getAllGoodsList();
            },
            chooseCurrentTowType(twoItem,index){
                this.twoTypeId=twoItem.id;
                if(index!==0){
                    if(this.chooseTag.length>=2){
                        this.chooseTag.splice(1, 1,{
                            id:twoItem.id,
                            level:2,
                            name:twoItem.typeName
                        });
                    }else {
                        this.chooseTag.push({
                            id:twoItem.id,
                            level:2,
                            name:twoItem.typeName
                        })
                    }
                }

                this.getAllGoodsList();
            },
            chooseCurrentMajorType(treItem,index){
                this.treCurrentIndex = index;
                this.getAllGoodsList();
            },
            getAllTypeData(){
                this.$store.dispatch('getIndexTypeAllList').then((res)=>{
                    let typeLists=[{
                        id:-1,
                        typeName:'全部'
                    }];
                    typeLists.push(...res.data);
                    this.typeList=typeLists;
                    for(var i=0;i<res.data.length;i++){
                        if(res.data[i].id==this.$route.params.oneTypeId){
                            this.typeTwoList=res.data[i].twoTypes;
                        }
                    }


                })
            },
            getAllGoodsList(){
                let params={
                    current:this.currentPage,
                    size:this.pageSize,
                    oneTypeId:this.oneTypeId,
                    twoTypeId:this.twoTypeId,
                    goodsName:this.goodsName,
                    rank:this.rank,
                    status:1
                };
                if(this.oneTypeId==-1){
                    delete params.oneTypeId
                }
                if(this.twoTypeId==-1){
                    delete params.twoTypeId
                }
                if(this.goodsName===''){
                    delete params.goodsName
                }
                this.$store.dispatch('findByShopIdForShopList',params).then((res)=>{
                    this.nowTime=res.nowTime;
                    this.totalPage=res.data.total;
                    this.goodsList=res.data.records;
                })
            },
        },
        watch:{
            'rank'(){
                this.getAllGoodsList();
            },
            $route(to, from) {
//                if(to.params.oneTypeId==this.oneTypeId){
//                    return;
//                }else {
//                    console.log(from,to)
//                    this.getActiveGoodsList()
//                }
                console.log(from,to)
                this.oneTypeId=to.query.oneTypeId?to.query.oneTypeId:-1;
                this.oneTypeName=to.query.oneTypeName?to.query.oneTypeName:'';
                this.twoTypeId=to.query.twoTypeId?to.query.twoTypeId:-1;
                this.twoTypeName=to.query.twoTypeName?to.query.twoTypeName:'';
                this.goodsName=to.query.goodsName?to.query.goodsName:'';
                this.getActiveGoodsList()
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../assets/css/common";
    .crumb-nav{
        padding:15px 0;
        .crumb{
            display: inline-block;
            height:25px;
            line-height:25px;
        }
        .yiChoose{
            vertical-align: middle;
            overflow: hidden;
            display: inline-block;
            li{
                &+li{margin-left:10px;}
                float: left;
                i{
                    color:#CECECE;
                }
            }
        }
    }
    .search-box{
        font-size:16px;
        color:#000000;
        background-color:#ffffff;
        padding:22px 25px;

        .scree-type{
            /*height:33px;*/
            overflow: hidden;
            line-height:32px;
            &+.scree-type{
                margin-top:16px;
            }
            &>li{
                float: left;
                padding:0 10px;
                height:32px;
                text-align: center;
                &.scree-name{
                    padding:0;
                    display: inline-block;
                    width:75px;
                    font-size:16px;
                    white-space:nowrap;
                    text-align: left;
                    margin-right:5px;
                    font-weight:600;
                    line-height: 32px;
                }
                &.type-item{
                    padding:0px;
                    width:1070px;
                    overflow: hidden;
                    &>.type-list{
                        &>li{
                            float: left;
                            padding:0 10px;
                            &:hover{color:$main-color;cursor: pointer;}
                            +li{
                                margin-left:15px;
                            }
                        }
                    }
                }
                &+li{
                    margin-left:15px;
                }
                &:nth-child(2){margin-left:0;}

            }

            .selected{
                color: $main-color;
                text-align:center;background-color:#F1FFF6;
                -webkit-border-radius: 4px;
                -moz-border-radius: 4px;
                border-radius: 4px;}
            .flag{color:#000000;font-size:16px;line-height:32px;padding-left:10px;}
            .price-between{width:auto;margin-left:25px;}
        }
        .sort-type{
            overflow: hidden;
            margin-top:16px;
            font-size:16px;
            color:#000;
            li{
                float: left;
                &.scree-name{
                    border:none;width:75px;
                    font-size:16px;
                    white-space:nowrap;
                    text-align: left;
                    margin-right:5px;
                    font-weight:600;
                    line-height: 32px;
                }
            }

            .type-item>li{
                &:hover{color:$main-color;cursor: pointer;}
                border:1px solid #ECECEC;
                width:112px;
                height:32px;
                line-height:32px;
                text-align:center;
                &+li{
                    border-left:none;
                }
                i{
                    color:#D3D3D3;
                }

                &.selected{color:$main-color;}
                /*&.isBaoYou{
                    border:none;
                    border-left:1px solid #ECECEC
                }*/

            }
        }
        .check-baoyou{
            width:16px;
            height:16px;
            border:1px solid #CECECE;
            background-color:#ffffff;
        }
    }
</style>
<style lang="scss">
    @import "../../assets/css/common";
    .el-tag{
        border:1px solid #CECECE;
        background-color:#ffffff;
        font-size:14px;
        color:#5A5A5A;
        height:25px;
        line-height:25px;
        -webkit-border-radius: 0px;
        -moz-border-radius: 0px;
        border-radius: 0px;
    }
    /*.el-tag--small{padding:0 5px;}*/
    .el-tag--plain .el-tag__close{color:#5A5A5A;&:hover{background-color:$main-color;}}
</style>